import { useCallback, useEffect, useRef } from "react";

/**
 * Custom hook to track if a component is mounted.
 * Useful for preventing state updates after component unmount.
 * Returns a stable function reference that can be safely used in dependency arrays.
 */
export function useIsMounted(): () => boolean {
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    return useCallback(() => isMountedRef.current, []);
}
